<template>
  <div class="finPagContainer">

    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="search-container">
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Pesquisar" outlined dense clearable hide-details
        class="search-bar">
      </v-text-field>
    </div>

    <Listar v-if="showFuncoes" @fecharCardListar="closeListar" :menu="menuSelected" />

    <v-data-table :headers="headers" :items="produtos" :search="search" class="configuracoes-table">
      <!-- Índice do item -->
      <template v-slot:item.index="{ item }">
        <span>{{ produtos.indexOf(item) + 1 }}</span>
      </template>

      <!-- Coluna "Estado" -->
      <template v-slot:item.estado="{ item }">
        <span>{{ item.estado === 1 ? 'Ativo' : 'Desativado' }}</span>
      </template>

      <!-- Ações por item -->
      <template v-slot:item.action="{ item }">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn fab dark color="#006699" class="action-btn" v-on="on">
              <v-icon>menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="exibirFuncoes(item)">
              <v-icon color="green" small class="mr-2">more</v-icon> Funções
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import Swal from 'sweetalert2';
import axios from '../../plugins/axios';
import Listar from '../../components/FuncaoPorRole/Listar.vue';


export default {
  data() {
    return {
      isLoading: false,
      search: "",
      headers: [
        { text: '#', value: 'index', },
        { text: 'Menu', value: 'menu' },
        { text: 'Total de Funções', value: 'itens' },
        { text: 'Autor', value: 'createdBy' },
        { text: 'Data', value: 'createdOn' },
        { text: 'Ações', value: 'action' },
      ],
      produtos: [],
      showFuncoes: false,
      menuSelected: null
    };
  },

  components: {
    Listar
  },

  created() {
    this.initializeItems();
  },

  methods: {
    async initializeItems() {
      this.isLoading = true;
      try {
        const response = await axios.get('/getFuncoesRole');
        this.produtos = response.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar os menus', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    exibirFuncoes(menu) {
      this.menuSelected = menu;
      this.showFuncoes = true;
    },

    closeListar(bool) {
      this.showFuncoes = false;
      this.menuSelected = null;
      if (bool) {
        this.initializeItems();
      }
    }
  }
};

</script>

<style></style>